<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="单位调查表录入" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" v-if="editData.djzt === '提交'" type="danger" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="单位调查表录入">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="基本情况表编号">
                                            <a-input ref="jbqkbbh" v-model="editData.jbqkbbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="调查日期" required>
                                            <a-date-picker
                                                ref="njrq"
                                                style="width:100%"
                                                valueFormat="YYYY-MM-DD"
                                                v-model="editData.njrq"
                                                placeholder="调查日期"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="调查年份" required>
                                            <FGDictSelect ref="njnf" dictNo="1111" v-model="editData.njnf" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型">
                                            <FGDictSelectCN ref="dwlx" dictNo="DW100101" v-model="editData.dwlx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="单位类别" required>
                                            <FGDictSelectCN ref="dwlb" dictNo="DW100102" v-model="editData.dwlb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="资质等级" required>
                                            <a-input ref="zzdj" v-model="editData.zzdj" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="区域名称" required>
                                            <a-input ref="qymc" v-model="editData.qymc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册地址" required>
                                            <a-input ref="zcdz" v-model="editData.zcdz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="办公地址" required>
                                            <a-input ref="bgdz" v-model="editData.bgdz" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="邮政编码" required>
                                            <a-input ref="yzbm" v-model="editData.yzbm" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="行业分类" required>
                                            <a-input ref="hyfl" v-model="editData.hyfl" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册资金（万元）" required>
                                            <a-input-number ref="zczj" v-model="editData.zczj" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="法人代表" required>
                                            <a-input ref="frdb" v-model="editData.frdb" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人固定电话" required>
                                            <a-input ref="frgddh" v-model="editData.frgddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="法人移动电话" required>
                                            <a-input ref="fryddh" v-model="editData.fryddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人" required>
                                            <a-input ref="lxr" v-model="editData.lxr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="固定电话" required>
                                            <a-input ref="gddh" v-model="editData.gddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话" required>
                                            <a-input ref="yddh" v-model="editData.yddh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="传真">
                                            <a-input ref="cz" v-model="editData.cz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="网址">
                                            <a-input ref="wz" v-model="editData.wz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位性质">
                                            <FGDictSelectCN ref="dwxz" dictNo="DW100103" v-model="editData.dwxz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职工总人数" required>
                                            <a-input-number ref="zgzrs" v-model="editData.zgzrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专业技术人员数" required>
                                            <a-input-number ref="zyjsrs" v-model="editData.zyjsrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="专职从事工程咨询人数" required>
                                            <a-input-number ref="zzcszxrs" v-model="editData.zzcszxrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册咨询师人数" required>
                                            <a-input-number ref="zczxsrs" v-model="editData.zczxsrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="高级职称人数" required>
                                            <a-input-number ref="gjzcrs" v-model="editData.gjzcrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="中级职称人数" required>
                                            <a-input-number ref="zjzcrs" v-model="editData.zjzcrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="初级职称人数" required>
                                            <a-input-number ref="cjzcrs" v-model="editData.cjzcrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="博士人数" required>
                                            <a-input-number ref="bsrs" v-model="editData.bsrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="硕士人数" required>
                                            <a-input-number ref="ssrs" v-model="editData.ssrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="本科人数" required>
                                            <a-input-number ref="bkrs" v-model="editData.bkrs" :min="0" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="会费缴纳标准(元/年)" required>
                                            <a-input-number
                                                ref="hfjnbz"
                                                v-model="editData.hfjnbz"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公面积（平方）" required>
                                            <a-input-number
                                                ref="bgmj"
                                                v-model="editData.bgmj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="其中自有面积(平方)" required>
                                            <a-input-number
                                                ref="zymj"
                                                v-model="editData.zymj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="计算机台数">
                                            <a-input-number ref="jsjts" v-model="editData.jsjts" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="质量体系认证">
                                            <a-input ref="zltxrz" v-model="editData.zltxrz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证日期">
                                            <a-date-picker
                                                ref="rzrq"
                                                v-model="editData.rzrq"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="认证机构">
                                            <a-input ref="rzjg" v-model="editData.rzjg" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="单位简介" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="dwjj" :rows="3" v-model="editData.dwjj" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="前期咨询收入(万元)" required>
                                            <a-input-number
                                                ref="qqzxsr"
                                                v-model="editData.qqzxsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="工程设计收入(万元)" required>
                                            <a-input-number
                                                ref="gcsjsr"
                                                v-model="editData.gcsjsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="工程监理收入(万元)" required>
                                            <a-input-number
                                                ref="gcjlsr"
                                                v-model="editData.gcjlsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="招标代理收入(万元)" required>
                                            <a-input-number
                                                ref="zbdlsr"
                                                v-model="editData.zbdlsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="项目管理收入(万元)" required>
                                            <a-input-number
                                                ref="xmglsr"
                                                v-model="editData.xmglsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="其他收入(万元)" required>
                                            <a-input-number
                                                ref="qtsr"
                                                v-model="editData.qtsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="收入合计(万元)" required>
                                            <a-input-number
                                                ref="hjsr"
                                                v-model="editData.hjsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="年上缴税金(万元)" required>
                                            <a-input-number
                                                ref="nsjsj"
                                                v-model="editData.nsjsj"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="税后利润(万元)" required>
                                            <a-input-number
                                                ref="shlr"
                                                v-model="editData.shlr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="年底资产总额(万元)" required>
                                            <a-input-number
                                                ref="ndzcze"
                                                v-model="editData.ndzcze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="省外咨询项目数(个)" required>
                                            <a-input-number ref="swzxxms" v-model="editData.swzxxms" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="省外收入(万元)" required>
                                            <a-input-number
                                                ref="swsr"
                                                v-model="editData.swsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="省外咨询固定资产投资额(万元)" required>
                                            <a-input-number
                                                ref="swzxgdzctze"
                                                v-model="editData.swzxgdzctze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="境外咨询项目数(个)" required>
                                            <a-input-number ref="jwzxxms" v-model="editData.jwzxxms" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="外汇收入(万美元)" required>
                                            <a-input-number
                                                ref="whsr"
                                                v-model="editData.whsr"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="境外咨询固定资产投资额(万元)" required>
                                            <a-input-number
                                                ref="jwzxgdzctze"
                                                v-model="editData.jwzxgdzctze"
                                                :min="0"
                                                :step="0.01"
                                                :formatter="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                :parser="
                                                    (value) => {
                                                        let reg = /^(-)*(\d+)\.(\d\d).*$/;
                                                        return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3');
                                                    }
                                                "
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="奖励和表彰" required>
                                            <a-input ref="jlbz" v-model="editData.jlbz" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="工商营业执照" required>
                                            <a-input ref="gsyyzz" v-model="editData.gsyyzz" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="设计证书" required>
                                            <a-input ref="sjzs" v-model="editData.sjzs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="监理证书" required>
                                            <a-input ref="jlzs" v-model="editData.jlzs" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="单据状态">
                                            <a-input ref="djzt" v-model="editData.djzt" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>

                                <a-row :gutter="[0, 9]">
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检亿元项目表明细">
                                <vxe-toolbar size="mini"> </vxe-toolbar>
                                <vxe-table
                                    ref="yyxmtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="yyxmTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="xmmc" title="项目名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center"></vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zxfwfw" title="咨询服务范围" align="center"></vxe-table-column>
                                    <vxe-table-column field="jsgm" title="建设规模" align="center"></vxe-table-column>
                                    <vxe-table-column field="gdzctze" title="固定资产投资额" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwmc" title="委托单位名称" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwlxr" title="委托单位联系人" align="center"></vxe-table-column>
                                    <vxe-table-column field="wtdwdh" title="委托单位电话" align="center"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"></vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检前期项目表明细">
                                <vxe-table
                                    ref="qqxmtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="qqxmTableData"
                                    :edit-config="{
                                        trigger: 'click',
                                        mode: 'row',
                                        showStatus: true,
                                        showIcon: false
                                    }"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_gh" title="咨询项目数|规划" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="zxxms_xmjys" title="咨询项目数|项目建议书" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_kybg" title="咨询项目数|可研报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_xmsqbg" title="咨询项目数|项目申请报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_zjsqbg" title="咨询项目数|资金申请报告" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_pg" title="咨询项目数|评估" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_jnps" title="咨询项目数|节能评审" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zxxms_gcxmgl" title="咨询项目数|工程项目管理" align="center"></vxe-table-column>
                                    <vxe-table-column field="gdzctze" title="固定资产投资额" align="center"></vxe-table-column>
                                    <vxe-table-column field="pgzxhze" title="评估咨询项目|核增额" align="center"></vxe-table-column>
                                    <vxe-table-column field="pgzxhje" title="评估咨询项目|核减额" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="100px"></vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>

                            <FGCollapsiblePanel title="年检客户反应表明细">
                                <vxe-table
                                    ref="Khfytable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="khfyTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column field="zybh" title="专业编号" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="zymc" title="专业名称" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="wcsl" title="完成数量" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjsl" title="评价数量" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjl" title="评价率(%)" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_yxxms" title="评价结果|优秀" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_lhxms" title="评价结果|良好" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_hgxms" title="评价结果|合格" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pjjg_bhgxms" title="评价结果|不合格" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="khfy_fcmyxms" title="咨询项目客户反应|非常满意项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_bjmyxms" title="咨询项目客户反应|比较满意项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_fyybxms" title="咨询项目客户反应|反应一般项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="khfy_fyjcxms" title="咨询项目客户反应|反应较差项目数" align="center" width="100px">
                                    </vxe-table-column>
                                    <vxe-table-column field="zxhtlyl" title="咨询合同履约率(%)" align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"> </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检咨询工程师表明细">
                                <vxe-table
                                    ref="zxgcstable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="zxgcsTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable></vxe-table-column>
                                    <vxe-table-column field="xm" title="姓名" align="center"></vxe-table-column>
                                    <vxe-table-column field="xb" title="性别" align="center"></vxe-table-column>
                                    <vxe-table-column field="zjlx" title="证件类型" align="center"></vxe-table-column>
                                    <vxe-table-column field="zjhm" title="证件号码" align="center"></vxe-table-column>
                                    <vxe-table-column field="nl" title="年龄" align="center" width="100px"></vxe-table-column>
                                    <vxe-table-column field="zc" title="职称" align="center"></vxe-table-column>
                                    <vxe-table-column field="zczy" title="职称专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="xl" title="学历" align="center"></vxe-table-column>
                                    <vxe-table-column field="xw" title="学位" align="center"></vxe-table-column>
                                    <vxe-table-column field="sxzy" title="所学专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="zczbh" title="注册咨询工程师(投资)|注册证编号" align="center"></vxe-table-column>
                                    <vxe-table-column field="zzy" title="注册咨询工程师(投资)|主专业 " align="center"></vxe-table-column>
                                    <vxe-table-column field="fzy" title="注册咨询工程师(投资)|辅专业" align="center"></vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"></vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="年检自查结果表明细">
                                <vxe-table
                                    ref="zcjgtable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="zcjgTableData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column field="zcnr" title="自查内容" align="center"> </vxe-table-column>
                                    <vxe-table-column field="zcyj" title="自查意见" align="center"> </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" align="center" width="180px"> </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>

                            <!-- 操作日志 -->
                            <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");

export default {
    name: "DwdcblrForm",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            dwxxData: {},
            editData: {},
            editDataLoading: false,
            yyxmTableData: [],
            yyxmTableDataLoading: false,
            qqxmTableData: [],
            qqxmTableDataLoading: false,
            khfyTableData: [],
            khfyTableDataLoading: false,
            zxgcsTableData: [],
            zxgcsTableDataLoading: false,
            zcjgTableData: [],
            zcjgTableDataLoading: false,
            isShow_qyxx: false,
            isShow_zyxx: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            // 流程跟踪参数
            historyProcessProps: {
                visible: false,
                billid: "",
                instanceId: "",
                processKey: "WXFYSH"
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "详情";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return (
                this.editDataLoading ||
                this.yyxmTableDataLoading ||
                this.qqxmTableDataLoading ||
                this.khfyTableDataLoading ||
                this.zxgcsTableDataLoading ||
                this.zcjgTableDataLoading
            );
        },
        attachCfg() {
            return {
                fktable: "NJ_JBQKB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "DWDC01"
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
        this.loadYyxmTableData();
        this.loadQqxmTableData();
        this.loadKhfyTableData();
        this.loadZxgcsTableData();
        this.loadZcjgTableData();
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                            this.initWorkFlow();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                });
        },
        loadYyxmTableData() {
            this.yyxmTableData = [];
            this.yyxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listYyxmMx",
                    {
                        yyxmbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.yyxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.yyxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        loadQqxmTableData() {
            this.qqxmTableData = [];
            this.qqxmTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listQqxmMx",
                    {
                        qqxmbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.qqxmTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.qqxmTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        loadKhfyTableData() {
            this.khfyTableData = [];
            this.khfyTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listKhfyMx",
                    {
                        khfybid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.khfyTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.khfyTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },

        loadZxgcsTableData() {
            this.zxgcsTableData = [];
            this.zxgcsTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZxgcsMx",
                    {
                        zxgcsbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zxgcsTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zxgcsTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },

        loadZcjgTableData() {
            this.zcjgTableData = [];
            this.zcjgTableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwdcgl/dwdc/listZcjgMx",
                    {
                        zcjgbid: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.zcjgTableDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.zcjgTableData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        //撤销
        unSubmit() {
            this.$FG_http
                .post("./api/main/dwdcgl/dwdc/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.dwmc.focus();
                    }
                });
        },

        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        },
        //加载审核流
        initWorkFlow() {
            this.historyProcessProps.visible = true;
            this.historyProcessProps.billid = this.editData.id;
            this.historyProcessProps.instanceId = this.editData.instanceid;
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
